import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { ValidState } from "@/models/enum/Enum";

type Props = {
  value: ValidState;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'ValidChip',
  props: {
    value: null
  },
  setup(__props: any) {

const props = __props as {
  value: ValidState;
};



const items = [
  { text: "有効", value: ValidState.Valid, color: "primary" },
  { text: "無効", value: ValidState.InValid, color: "" }
] as const;

const item = computed(() => items.find(e => e.value === props.value));

return { __sfc: true,props, items, item }
}

})